import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import { envAwarePost } from '../../util/util'

export const getAchievements = createAsyncThunk(
	'getAchievements',
	async (payload) => envAwarePost('api/achievements/api.php',{
		action: 'getAllAchievements',
		...payload
	})
)


const achievementsAdapter = createEntityAdapter()

const achievementsSlice = createSlice({
	name: 'achievements',
	initialState: achievementsAdapter.getInitialState({loading:"idle"}),
	reducers: {},
	extraReducers: {
		[getAchievements.pending]: (state, action) =>{
			state.loading = "pending"
		},
		[getAchievements.fulfilled]: (state, action) => {
			const { success, data } = action.payload
			if (success == 1) {
				achievementsAdapter.upsertMany(state, data)
				state.loading="idle"
			}
		}
	}
})

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllAchievements,
	selectById: selectAchievementById,
	selectIds: selectAchievementsIds
} = achievementsAdapter.getSelectors(state => state.achievements)


export default achievementsSlice.reducer